import React, { useState, useEffect } from "react";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import { Link } from "react-router-dom";
import { GoDotFill } from "react-icons/go";
import OrderItemStatus from "./OrderItemStatus/OrderItemStatus";
import { IoMdArrowDropleft } from "react-icons/io";
import { IoMdArrowDropright } from "react-icons/io";
import "./MyOrders.css";

const createSlug = (text) => {
  return text
    ?.toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");
};

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  // const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const companyCode = initialAuthState.companyCode;
  const unitCode = initialAuthState.unitCode;

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const statusOptions = [
    "delivered",
    "cancelled",
    // "returned",
    "pending",
    "shipped",
    // "request_raised",
    // "request_approved",
    // "request_reject",
    // "request_sucess",

    "replacement_requested",
    "replacement_approved",
    "replacement_rejected",
    "replacement_in_progress",
    "replaced",
  ];

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    filterOrders();
    setCurrentPage(1);
  }, [orders, selectedStatuses, searchTerm, fromDate, toDate]);

  const fetchOrders = async () => {
    try {
      const payload = { companyCode, unitCode };
      const response = await ApiService.post(
        "client/getWebClientDetailsById",
        payload,
      );
      if (response.status) {
        setOrders(response.data.orders || []);
      } else {
        console.error("Error fetching orders");
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  // const handleStatusChange = (status) => {

  //   setSelectedStatuses((prev) =>
  //     prev.includes(status)
  //       ? prev.filter((s) => s !== status)
  //       : [...prev, status]
  //   );
  // };

  const handleStatusChange = (status) => {
    setSelectedStatuses((prev) => (prev === status ? "" : status));
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  // const filterOrders = () => {
  //   let filtered = orders;


  //   // Filter by status
  //   if (selectedStatuses.length > 0) {
  //     const lowerCaseStatuses = selectedStatuses.map((s) => s.toLowerCase());
  //     filtered = filtered.filter((order) =>
  //       lowerCaseStatuses.includes(order.orderStatus?.toLowerCase())
  //     );
  //   }

  //   // Filter by search term
  //   if (searchTerm) {
  //     filtered = filtered.filter((order) =>
  //       order.orderItems.some((item) =>
  //         item.name?.toLowerCase().includes(searchTerm) ||
  //         order.id?.toString().includes(searchTerm)
  //       )
  //     );
  //   }

  //   setFilteredOrders(filtered);
  // };

  const filterOrders = () => {
    const normalize = (text) =>
      (text || "").toLowerCase().replace(/\s+/g, " ").trim();

    const normalizedSearch = normalize(searchTerm);

    let filtered = orders.map((order) => {
      let filteredItems = order.items || [];

      // ✅ Status filter
      // if (selectedStatuses.length > 0) {
      //   const lowerStatuses = selectedStatuses.map((s) => s.toLowerCase());

      //   filteredItems = filteredItems.filter((item) =>
      //     lowerStatuses.includes(item.itemStatus?.toLowerCase())
      //   );
      // }

      if (selectedStatuses) {
        filteredItems = filteredItems.filter(
          (item) =>
            item.itemStatus?.toLowerCase() === selectedStatuses.toLowerCase(),
        );
      }

      // ✅ Search filter
      if (searchTerm) {
        filteredItems = filteredItems.filter((item) => {
          const deviceName = item.device?.name || "";
          const orderItemNumber = item.orderItemNumber || "";

          return (
            normalize(deviceName).includes(normalizedSearch) ||
            normalize(orderItemNumber).includes(normalizedSearch)
          );
        });
      }

      if (fromDate || toDate) {
        const orderDate = order.createdAt ? new Date(order.createdAt) : null;

        if (!orderDate) {
          filteredItems = [];
        } else {
          if (fromDate) {
            const from = new Date(fromDate);
            from.setHours(0, 0, 0, 0);

            if (orderDate < from) {
              filteredItems = [];
            }
          }

          if (toDate) {
            const to = new Date(toDate);
            to.setHours(23, 59, 59, 999);

            if (orderDate > to) {
              filteredItems = [];
            }
          }
        }
      }


      return {
        ...order,
        items: filteredItems, // 🔥 KEY FIX
      };
    });

    // ✅ Remove empty orders
    filtered = filtered.filter((order) => order.items.length > 0);

    setFilteredOrders(filtered);
  };

  const clearFilters = () => {
    setSelectedStatuses("");
    setSearchTerm("");
    setFromDate(""); // ✅ ADD
    setToDate(""); // ✅ ADD
  };

  const getStatusColor = (status) => {
    const statusLower = status?.toLowerCase();
    switch (statusLower) {
      case "delivered":
      case "success":
      case "request_sucess":
        return "status-delivered";
      case "pending":
      case "request_raised":
        return "status-pending";
      case "received":
        return "status-received";
      case "dispatched":
      case "request_approved":
        return "status-dispatched";
      case "cancelled":
      case "aborted":
      case "request_reject":
        return "status-cancelled";
      default:
        return "status-pending";
    }
  };

  const flatItems = filteredOrders.flatMap((order) =>
    order.items.map((item) => ({
      ...item,
      orderId: order.id,
      deviceDetails: order.deviceDetails,
    })),
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const paginatedItems = [...flatItems]
    .reverse()
    .slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(flatItems.length / itemsPerPage);

  return (
    <div className="myorders-container">
      <div className="myorders-main">
        <div className="myorders-header">
          <h1 className="myorders-title">My Orders</h1>
          <p className="myorders-subtitle">Track and manage your orders</p>
        </div>

        <div className="myorders-controls">
          <>
            <p className="myorders-date-label">Filter by Date</p>
            <div className="myorders-date-search-container">
              <div className="myorders-date-filter">
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="myorders-date-input"
                />

                <span className="myorders-date-separator">to</span>

                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  className="myorders-date-input"
                />
              </div>

              {/* <div className="myorders-search-container"> */}
              <div className="myorders-search">
                <input
                  type="text"
                  className="myorders-search-input"
                  placeholder="Search by order ID or product name..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <button
                  className="myorders-clear-filters"
                  onClick={clearFilters}
                >
                  Clear Filters
                </button>
                {/* <button className="myorders-search-button">
                  Search
                </button> */}
              </div>
              {/* {(selectedStatuses.length > 0 || searchTerm) && ( */}

              {/* )} */}
              {/* </div> */}
            </div>
          </>

          <div className="filter-bar">
            {statusOptions.map((status) => (
              <button
                key={status}
                className={`status-pill ${
                  selectedStatuses === status ? "active" : ""
                }`}
                onClick={() => handleStatusChange(status)}
              >
                {status.replace(/_/g, " ")}
                {selectedStatuses === status && (
                  <span className="pill-count">✓</span>
                )}
              </button>
            ))}
          </div>
        </div>

        {filteredOrders.length === 0 ? (
          <div className="myorders-empty">
            <div className="empty-icon">📦</div>
            <h3>No order Items found</h3>
            <p>
              {orders.length === 0
                ? "You haven't placed any orders yet."
                : "No order items match your current filters."}
            </p>
            {(selectedStatuses.length > 0 || searchTerm) && (
              <button
                className="myorders-clear-filters-btn"
                onClick={clearFilters}
              >
                Clear all filters
              </button>
            )}
          </div>
        ) : (
          <div className="myorders-list">
            {/* {[...filteredOrders].reverse().map((order) => ( */}
            {(paginatedItems || []).map((item) => {
              const device = Array.isArray(item.deviceDetails)
                ? item.deviceDetails.find(
                    (d) => Number(d.deviceId) === Number(item.deviceId),
                  )
                : null;

              return (
                <div className="myorders-order-order-card" key={item.id}>
                  <Link
                    // to={`/orders/${item.orderId}/items/${item.id}`}
                    to={`/orders/${createSlug(`order-${item.orderId}`)}/items/${createSlug(
                      `${item?.device?.name || "item"}-${item.id}`,
                    )}`}
                    state={{ activeTab: "orders" }}
                    className="order-item-link"
                  >
                    <div className="my-orders-order-item">
                      <div className="my-orders-order-image-heading-container">
                        <div className="my-orders-item-image-replace-container">
                          <div className="item-image-container">
                            <img
                              src={
                                item?.device?.image?.[0] ||
                                "https://storage.googleapis.com/way4track-application/device_media/1763618936164-image_1763618896161_328.png"
                              }
                              alt={item?.device?.name}
                              className="order-item-image"
                            />
                          </div>

                          {item.parentOrderItemId && (
                            <span className="replacement-badge">
                              [Replacement]
                            </span>
                          )}
                        </div>

                        <div className="item-details">
                          <h4 className="item-name">{item?.device?.name}</h4>

                          <div className="item-specs">
                            {item.isRelaySelected && item.relayAmount > 0 && (
                              <span className="my-orders-order-item-config-badge">
                                ⚡ Relay Included
                              </span>
                            )}

                            {(item.networkType || item.networkAmount > 0) && (
                              <span className="my-orders-order-item-config-badge">
                                📶 {item.networkType || "Network not selected"}
                              </span>
                            )}

                            {(item.subscriptionType ||
                              item.subscriptionAmount > 0) && (
                              <span className="my-orders-order-item-config-badge">
                                🔄 {item.subscriptionType || "No Subscription"}
                              </span>
                            )}
                          </div>

                          <span className="my-orders-order-item-config-badge">
                            Quantity: {item?.quantity}
                          </span>
                        </div>
                      </div>

                      <div className="price-amount">₹{item.totalPrice}</div>

                      <div className="my-orders-order-item-delivery-info">
                        <OrderItemStatus
                          status={item.itemStatus}
                          deliveredAt={item.deliveredAt}
                        />
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}

            <div className="pagination-container">
              {/* PREV */}
              <button
                className="pagination-nav-btn"
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
              >
                <IoMdArrowDropleft className="btn-arrow-icon" />
              </button>

              {/* PAGE NUMBERS */}
              {(() => {
                const pages = [];
                const maxVisible = 5;

                let start = Math.max(currentPage - 2, 1);
                let end = Math.min(start + maxVisible - 1, totalPages);

                if (end - start < maxVisible - 1) {
                  start = Math.max(end - maxVisible + 1, 1);
                }

                if (start > 1) {
                  pages.push(
                    <button
                      key={1}
                      onClick={() => setCurrentPage(1)}
                      className="pagination-btn"
                    >
                      1
                    </button>,
                  );
                  if (start > 2)
                    pages.push(<span key="start-ellipsis">...</span>);
                }

                for (let i = start; i <= end; i++) {
                  pages.push(
                    <button
                      key={i}
                      onClick={() => setCurrentPage(i)}
                      className={`pagination-btn ${currentPage === i ? "active" : ""}`}
                    >
                      {i}
                    </button>,
                  );
                }

                if (end < totalPages) {
                  if (end < totalPages - 1)
                    pages.push(<span key="end-ellipsis">...</span>);
                  pages.push(
                    <button
                      key={totalPages}
                      onClick={() => setCurrentPage(totalPages)}
                      className="pagination-btn"
                    >
                      {totalPages}
                    </button>,
                  );
                }

                return pages;
              })()}

              {/* NEXT */}
              <button
                className="pagination-nav-btn"
                onClick={() =>
                  setCurrentPage((p) => Math.min(p + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                <IoMdArrowDropright className="btn-arrow-icon" />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyOrders;
